let _selectors = {
    hero: '.hero',
    heroOverlay: '.hero-inner_overlay-image',
    heroSection: '.hero-section',
    heroSectionOverlap: '.hero-section_overlay-image',
    heroSectionAnim: '.hero-section_overlay-image.overlay-image_anim',
    editorTarget: '.editor-styles-wrapper',
};

// Cached Elements.
let _el = {};

// Module Variables
let _vars = {};

// Check if we're in the admin area
const isAdmin = () => {
    return document.body.classList.contains('wp-admin');
}

// Module init
const _init = () => {

    // This is not ideal, but needed since this code runs in multiple contexts
    // On the frontend we want to run the code immediately (on DOMContentLoaded)
    // In the editor we need to wait until the UI has rendered (window.load)
    // Note .editor-styles-wrapper isn't in the DOM until the editor has loaded

    if (isAdmin()) {
        window.addEventListener('load', () => {
            _setElements();
            _bindEvents();
        });
    } else {
        // The interactive square animation dispatches this custom event when it's ready
        if (window.animationInitialised) {
            _setElements();
            _bindEvents();
        } else {
            window.addEventListener('animationInitialised', () => {
                window.animationInitialised = true;
                _setElements();
                _bindEvents();
            });
        }
    }
};

const _loadImages = () => {
    const img1 = new Image();
    const img2 = new Image();

    img1.src = _el.hero.dataset.bgImage;
    img2.src = _el.hero.dataset.animImage;
    
    Promise.all([
        new Promise(resolve => img1.addEventListener('load', resolve)),
        new Promise(resolve => img2.addEventListener('load', resolve))
    ]).then(() => {
        _el.hero.classList.add('anim-fade-in');
    });
};

const _bindEvents = () => {
    
    // Hero (homepages)
    if(_el.hero && _el.heroOverlay) {
        _el.hero.classList.add('is-initialised');

        if (!isAdmin()) {
            // Preload images for the hero before it fades in
            _loadImages();
        }
    }

    // Hero Section (other pages)
    if (_el.heroSection) {
        _el.heroSection.classList.add('is-initialised');
    }
};

// Set/Reset and Cache Module elements
const _setElements = () => {
    Object.keys(_selectors).forEach(key => {
        const el = document.querySelectorAll(_selectors[key]);
        _el[key] = el.length === 1 ? el[0] : null;
        _vars[key] = el.length;
        // console.log(`${key}: found ${el.length} elements for selector ${_selectors[key]}`);
    });
};

const Hero = {
    init: _init,
};

export default Hero;